import React from "react"
import FormSection from "../FormSection"
import TextAreaInput from "../TextAreaInput"

export default function AdditionalInformation() {
  return (
    <FormSection title="Additional Information">
      <div className="space-y-6">
        <TextAreaInput
          label="Besides you, who else will be involved in making decisions about this project?"
          name="others_involved_in_project_decisions"
          className="flex flex-col col-span-2"
        />
        <TextAreaInput
          label="Additional information that you would like us to know"
          name="additional_information"
          className="flex flex-col col-span-2"
        />
      </div>
    </FormSection>
  )
}
